const SET_ROW = 'haggle/SET_ROW';

export default {
  SET_ROW,
};
